import { useState, useCallback } from 'react';
import { pw9224Api } from '../../../services/pw9224Api';

export function usePW9224Navigation(onNavigate: (id: string) => Promise<void>) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  const loadList = useCallback(async (): Promise<string[]> => {
    const res = await pw9224Api.list(1, 10000);
    const ids = (res.data || []).map(r => r.f924_01).filter(Boolean);
    setAllIds(ids);
    return ids;
  }, []);

  const navTo = useCallback(async (idx: number, isEditing: boolean) => {
    if (idx < 0 || idx >= allIds.length || isEditing) return;
    setCurrentIdx(idx);
    await onNavigate(allIds[idx]);
  }, [allIds, onNavigate]);

  return { allIds, currentIdx, setCurrentIdx, loadList, navTo };
}
